import { render, staticRenderFns } from "./ComponentPage.vue?vue&type=template&id=22dd11df&scoped=true&"
import script from "./ComponentPage.vue?vue&type=script&lang=js&"
export * from "./ComponentPage.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPage.vue?vue&type=style&index=0&id=22dd11df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd11df",
  null
  
)

export default component.exports